import React from "react";
import { Collapse, ControlGroup, Tag } from "@blueprintjs/core";

import { inject, observer } from "mobx-react";
import SysInvCard from "./SysInvCard";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import { nanoid } from "nanoid";
import { apiCallPost } from "../../fns/util";
import cogoToast from "cogo-toast";

class PlanSysInv extends React.Component {
  state = { collapse: true, searching: false, searchResults: [] };
  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/clinical/${this.props.authStore.prefix}/unisearch`,
        { prefix: "sysinv", query: string }
      );
      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderShort = () => {
    if (
      !this.props.data.systemicInvestigations ||
      !this.props.data.systemicInvestigations.length
    ) {
      return (
        <Tag minimal large>
          No systemic parameters added.
        </Tag>
      );
    }
    let inv = this.props.data.map((each) => each.testName);
    let txt = inv.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  renderHeading = () => {
    let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
    if (terminals.includes(this.props.data.lifecycle)) {
      return (
        <ControlGroup>
          <Tag large intent="primary">
            Systemic Parameters
          </Tag>
        </ControlGroup>
      );
    }
    return (
      <ControlGroup>
        <Tag large intent="primary">
          Systemic Parameters
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <AsyncSelWrap
            placeholder="Systemic Parameters..."
            searching={this.state.searching}
            items={this.state.searchResults}
            selectedItem={null}
            update={(item) => this.search(item)}
            onChange={(item) => {
              let dd = item.data;
              dd["nanoid"] = nanoid();
              dd["_id_sr"] = item._id;
              dd["type"] = "new";
              dd["checked"] = false;
              this.props.onUpdate({
                systemicInvestigations: [
                  ...this.props.data.systemicInvestigations,
                  dd,
                ],
              });
            }}
          />
        )}
      </ControlGroup>
    );
  };
  renderInvestigations = () => {
    if (
      !this.props.data.systemicInvestigations ||
      !this.props.data.systemicInvestigations.length
    ) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No systemic investigations added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.props.data.systemicInvestigations.map((each, idx) => {
      return (
        <>
          <SysInvCard
            key={each._id}
            data={each}
            update={(vv) => {
              let meds = this.props.data.systemicInvestigations;
              meds[idx].value = vv;
              this.props.onUpdate({ systemicInvestigations: meds });
            }}
            remove={() => {
              let meds = this.props.data.systemicInvestigations;
              meds.splice(idx, 1);
              this.props.onUpdate({ systemicInvestigations: meds });
            }}
          />
        </>
      );
    });
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "start",
          justifyContent: "left",
          padding: `${this.props.horizontal ? "0px" : "10px"}`,
        }}
      >
        {this.renderHeading()}
        <Collapse isOpen={this.state.collapse}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {this.renderInvestigations()}
          </div>
        </Collapse>
      </div>
    );
  }
}
export default inject("authStore")(observer(PlanSysInv));
